import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { ChainWideMistsComponent } from '@app/features/mists/modules/chain-wide-mists/chain-wide-mists.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        ChainWideMistsComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class ChainWideMistsModule {}